import useAuth from "../../hooks/useAuth";

export let can = () => false;

const Permission = () => {
    const {user, courierPermissions,shopPermissions, nonShopPermissions} = useAuth();
        can = (permission, shopId) => {
        if (user?.roles?.find(({name}) => name == 'admin') && !('shopId' && 'courierId' in user?.roles?.find(({name}) => name == 'admin'))) {
            return true;
        } else {
            return (() => {
                const isPermissionAllow = (shopPermissions || []).filter(item => item.shopId == shopId).find(({name}) => name == permission) ? true : false;
                const isPermissionAllowCourier = (courierPermissions || []).filter(item => item.courierId == shopId).find(({name}) => name == permission) ? true : false;

                if (isPermissionAllow) {
                    return true
                } else if(isPermissionAllowCourier){
                    return true
                }
                 else {
                    const isRoleAllow = (nonShopPermissions || []).find(({name}) => name == permission) ? true : false;
                    return isRoleAllow
                }
                return false
            })()
        }
    };

    return <></>;
};

export default Permission;
